module.exports = __webpack_public_path__ + "static/img/two.0c5247e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/13/two.png
// module id = DiuU
// module chunks = 1